import classNames from "classnames";
import * as React from "react";
import * as styles from "../Input.less";
import * as stylesTextArea from "../TextArea.less";

export const InputIconWrapper: React.FC<Pick<React.HTMLAttributes<HTMLDivElement>, "className">> = ({
    children,
    className,
}) => <div className={classNames(styles.input_icon, className)}>{children}</div>;

export const InputIconStyles = {
    Details: stylesTextArea.details_input_icon,
};
